import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminCsvExportIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="m10.6667 3.33332-.94668.94667-1.06-1.06v7.44671h-1.32V3.21999l-1.06 1.06-.94667-.94667L8.00002.666656 10.6667 3.33332Zm2.6667 3.33334V14c0 .7333-.6 1.3333-1.3334 1.3333H4.00002c-.74 0-1.33333-.6-1.33333-1.3333V6.66666c0-.74.59333-1.33334 1.33333-1.33334h2v1.33334h-2V14H12V6.66666h-2V5.33332h2c.7334 0 1.3334.59334 1.3334 1.33334Z" />
  </Icon>
);

export default memo(AdminCsvExportIcon);
